import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAM18x15NZVP3CJtthDZsBj0V-MNrwePk0",
  authDomain: "photobooth-cccd9.firebaseapp.com",
  projectId: "photobooth-cccd9",
  storageBucket: "photobooth-cccd9.firebasestorage.app",
  messagingSenderId: "76495862779",
  appId: "1:76495862779:web:d344a8a7a0ff8a3134695e",
  measurementId: "G-0X6ZK2DTN4"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };